export const REACT_APP_COGNITO_REGION = process.env.REACT_APP_COGNITO_REGION
export const REACT_APP_COGNITO_USERPOOL_ID = process.env.REACT_APP_COGNITO_USERPOOL_ID
export const REACT_APP_COGNITO_IDENTITYPOOL_ID = process.env.REACT_APP_COGNITO_IDENTITYPOOL_ID
export const REACT_APP_COGNITO_CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID
export const REACT_APP_COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN